import AccessStores from './AccessStores';
import React from 'react';
export default AccessStores;
